// import Spline from "@splinetool/react-spline";

export default function BlobSmall() {
  const iconPath = process.env.PUBLIC_URL;
  return (
    // <Spline scene="https://prod.spline.design/J2GZpqd42b6wuMKa/scene.splinecode" />
    <img src={iconPath + "/blob-small.png"} alt="" />
  );
}
